import * as React from 'react';
import {Box} from '@mui/material';
import {ChartContainer} from '../../Common/ChartContainer';
import {configSchema} from './configSchema';
import {ISubmissionProps} from '@/containers/FdcMilanoVolunteers/resources/submission';

const TrainingActivities = ({submissions}: {submissions: ISubmissionProps[]}) => {
    return (
        <Box>
            <ChartContainer
                configSchema={configSchema(submissions)}
                usePercentage={true}
            />
        </Box>
    )
}

export default TrainingActivities;